<template>
  <div class="absolute" v-if="show">
    <div class="fixed inset-0 flex items-center justify-center space-x-4">
      <div :class="sizeClass" class="animate-pulse animation-delay-none bg-blue-500 rounded-full opacity-10"></div>
      <div :class="sizeClass" class="animate-pulse animation-delay-100 bg-blue-500 rounded-full opacity-10"></div>
      <div :class="sizeClass" class="animate-pulse animation-delay-300 bg-blue-500 rounded-full opacity-10"></div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'small'
      }
    },
    computed:{
      sizeClass(){
        return this.size === 'big' ? 'w-10 h-10' : 'w-8 h-8'
      }
    },
}
</script>
